import React from 'react';
import Facebook from '../../../images/Wfb.png';
import Youtube from '../../../images/Wyoutube.png';
import Insta from '../../../images/Winsta.png';
import Spotify from '../../../images/Wspotify.png';
import { Link } from 'react-router-dom';

const HomeFooter = () => {
  return (
    <div>
      <footer className='HomeFooter'>
        <div>
          <div>
            <div>
              <h3 className='footer_heading-style '>Submit</h3>
              <p className='footer_para-style'>your music</p>
            </div>
            <div>
              <p>Release your music on our label</p>
              <Link to='#' className='text-success'>
                evidence@musichighcourt.com
              </Link>
            </div>
            <div className='socialmedia_icons'>
              <span>
                <img src={Spotify} alt='' />
              </span>
              <span>
                <img src={Youtube} alt='' />
              </span>
              <span>
                <img src={Insta} alt='' />
              </span>
              <span>
                <img src={Facebook} alt='' />
              </span>
            </div>
          </div>
          <div>
            <div>
              <h4>Hear from us</h4>
            </div>
            <div>
              <p>Subscribe to our newsletter and receive the latest updates</p>
            </div>
            <div className='divider-white'></div>
            <div>
              <button className='btn btn-theam'>Subscribe</button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
export default HomeFooter;
